import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Information from '../../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../../Shared/InformationContent/EFInformation';
import applicationService from '../../../../../../services/Public/Application/application.service';
import efApplicationService, { getSections } from '../../../../../../services/Public/Application/EF/efApplication.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import ReviewPdf from '../../../../../Shared/Card/ReviewPdf';
import { List } from 'rsuite';
import shoppingCartService from '../../../../../../services/Public/shoppingCart.service';
import Swal from 'sweetalert2';

function ReviewPage() {
    const [hasLoaded, setHasLoaded] = useState(true)
    const [hasIssues, setHasIssues] = useState(true)
    const push = useNavigate();
    const appId = useSelector(x => x.currentApplicationId);
    const routes = useSelector(x => x.currentRoutes);
    const [violationIssuesHtml, setViolationIssuesHtml] = useState();
    const sectionId = 9;
    const [allSections, setAllSections] = useState([]);
    const [sectionData, setSectionData] = useState({});
    useEffect(() => {
        getSections().then(setAllSections);
        efApplicationService.efGetSection(appId, sectionId).then((response) => {
            setSectionData(response.data);
        })
    }, [])

    const navigateToPage = (sectionId) => {
        push(routes.filter(x => x.sectionId == (sectionId))[0].route)
    }
    const validateApplication = () => {
        setHasLoaded(false);
        applicationService.validateFirmApplication(appId).then((response) => {
            let errors = response.data.map((error, i) => {
                return <List.Item key={i} index={i} onClick={() => { navigateToPage(error.sectionId) }}>
                    Error{error.errors.length > 1 ? 's' : ''} in <b>{allSections.filter(x => x.id == error.sectionId)[0].sectionTitle}</b>: {error.errors.join(', ')}
                </List.Item>
            })
            if (response.data?.length)
                setViolationIssuesHtml(
                    <List hover bordered>
                        {errors}
                    </List>
                )
            else {
                setViolationIssuesHtml('')
                setHasIssues(false);
                Swal.fire("Validation Successful", `Your application passed all validation checks.  Click "OK", then click "Submit Application".`, 'success')
            }
            setHasLoaded(true);
        })
    }
    const submitApplication = () => {
        setHasLoaded(false);
        shoppingCartService.addToShoppingCart(appId, 3).then((data) => {
            if (data.data) {
                push('/firm/shoppingcart');
            }
        })

        //applicationService.submitFirmApplication(appId).then((data) => {
        //    if (data.data?.length) {
        //        setHasIssues(true);
        //        let errors = data.data.map((error, i) => {
        //            return <List.Item key={i} index={i} onClick={() => { navigateToPage(error.sectionId) }}>
        //                Error{error.errors.length > 1 ? 's' : ''} in <b>{allSections.filter(x => x.id == error.sectionId)[0].sectionTitle}</b>: {error.errors.join(', ')}
        //            </List.Item>
        //        })
        //        setViolationIssuesHtml(
        //            <List hover bordered>
        //                {errors}
        //            </List>
        //        )
        //        setHasLoaded(true);
        //    }
        //    else {
        //        setHasIssues(false);
        //        setViolationIssuesHtml("")
        //        efApplicationService.efGetSection(appId, sectionId).then((response) => {
        //            setSectionData(response.data);
        //            setHasLoaded(true);
        //        })
        //    }
        //})
    }

    return (
        <div>
            <Container fluid>
                <b>Engineering Firm Application</b>
                <h4 className="mb-3">Review</h4>
                <Row>
                    <Col>
                        <Information content={GetAppInformationContent("review")} className="mb-3" />
                    </Col>
                </Row>
                <br />
                {sectionData.isUserEditable ?
                    <Button onClick={validateApplication} name="reviewApplication">Validate Application</Button> : <ReviewPdf id={appId} parentTypeId={1} />
                }
                {hasLoaded ?
                    <>
                        {
                            (!hasIssues && sectionData.isUserEditable) &&
                            <><span className="ms-2"><ReviewPdf id={appId} parentTypeId={1} /></span>
                                <Button name="addToCartBtn" onClick={submitApplication} variant="danger" className="ms-2">Submit Application</Button>
                            </>
                        }
                        <Button name="backToSections" as={Link} to="/firm/efapp/sections" variant="primary" className="ms-2" >Back to Sections</Button>
                        <br />
                        <br />
                        {violationIssuesHtml}
                    </>
                    : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default ReviewPage